import HeliumController from './helium.controller';

angular.module('skeyenoteWebApp')
  .controller('HeliumCtrl', HeliumController);
